export const projects = [
  {
    id: 1,
    title: "The Artist & The Pervert",
    slug: "the-artist-and-the-pervert",
    categories: ["institutions"],
    desc: "Feature documentary. 40+ Film Festivals",
    allOrder: 1,
    size: "wide",
    image: "/images/work/artist-pervert.webp",
  },
  {
    id: 2,
    title: "IKEA Cinema Catalogue",
    slug: "ikea-cinema-catalogue",
    categories: ["campaigns"],
    desc: "Guerilla stunt",
    allOrder: 2,
    size: "tall",
    heroOnFilter: ["campaigns"],
    image: "/images/work/ikea-cinema.webp",
  },
  {
    id: 3,
    title: "PORSCHE Dreamjob",
    slug: "porsche-dreamjob",
    categories: ["campaigns"],
    desc: "Recruitment campaign",
    allOrder: 3,
    size: "normal",
    image: "/images/work/porsche-00g.webp",
  },
  {
    id: 4,
    title: "Bombs from Berlin",
    slug: "bombs-from-berlin",
    categories: ["campaigns", "institutions"],
    desc: "PR stunt against arms exports",
    allOrder: 4,
    size: "normal",
    image: "/images/work/bombs-from-berlin.webp",
  },
  {
    id: 5,
    title: "Karada House",
    slug: "karada-house",
    categories: ["institutions", "systems"],
    desc: "Co-founder & director. A queer art space",
    allOrder: 5,
    size: "tall",
    heroOnFilter: ["institutions"],
    image: "/images/work/karada-house.webp",
  },
  {
    id: 6,
    title: "BUND Time is Running Out",
    slug: "bund-time-is-running-out",
    categories: ["campaigns", "institutions"],
    desc: "Cannes Gold. Environmental campaign",
    allOrder: 6,
    size: "wide",
    image: "/images/work/bund-time-is-running-out.webp",
  },
  {
    id: 7,
    title: "Fresh’N’Friends",
    slug: "fresh-n-friends",
    categories: ["campaigns"],
    desc: "Package Design. Red Dot Grand Prix",
    allOrder: 7,
    size: "normal",
    image: "/images/work/fresh-n-friends.webp",
  },
  {
    id: 8,
    title: "Die PARTEI iDemo",
    slug: "die-partei-idemo",
    categories: ["campaigns"],
    desc: "4x ADC Gold",
    allOrder: 9,
    size: "normal",
    heroOnFilter: ["all"],
    image: "/images/work/die-partei-idemo.webp",
  },
  {
    id: 9,
    title: "SIEMENS Laundry Gallery",
    slug: "siemens-laundry-gallery",
    categories: ["campaigns"],
    desc: "Art on washing machines",
    allOrder: 8,
    size: "wide",
    image: "/images/work/siemens-laundry-gallery.webp",
  },
  {
    id: 10,
    title: "IKEA Delivery",
    slug: "ikea-delivery",
    categories: ["campaigns"],
    desc: "Service campaign. 7x LIA",
    allOrder: 10,
    size: "normal",
    image: "/images/work/Ikea_delivery-00g.webp",
  },
  {
    id: 11,
    title: "Kino-Zeit",
    slug: "kino-zeit",
    categories: ["systems"],
    desc: "Cinema magazine rebrand",
    allOrder: 11,
    size: "normal",
    heroOnFilter: ["systems"],
    image: "/images/work/kino-zeit.webp",
  },
  {
    id: 12,
    title: "Museum of Bureaucracy",
    slug: "museum-of-bureaucracy",
    categories: ["systems", "institutions"],
    desc: "An exhibition that filed itself",
    allOrder: 12,
    size: "wide",
    image: "/images/work/museum-of-bureaucracy.webp",
  },
  {
    id: 13,
    title: "Projektil",
    slug: "projektil",
    categories: ["institutions"],
    desc: "International design lecture series",
    allOrder: 13,
    size: "normal",
    image: "/images/work/projektil.webp",
  },
  {
    id: 14,
    title: "BOSCH Fresh Stone Age Meat",
    slug: "bosch-fresh-stone-age-meat",
    categories: ["campaigns"],
    desc: "Promotion. 5x Cannes Lions",
    allOrder: 14,
    size: "wide",
    image: "/images/work/bosch-fresh-stone-age-meat.webp",
  },
];